/* istanbul ignore file */
import { array as codecArray, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { RubricItemInputAsJSON } from './RubricItemInputAsJSON';
const RubricRowBaseInputBaseAsJSONParser = 
/* #__PURE__ */ parsers.object([
    ['header', codecString],
    ['description', codecString],
    ['items', /* #__PURE__ */ codecArray(RubricItemInputAsJSON)],
]);
export class RubricRowBaseInputBaseAsJSON extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RubricRowBaseInputBaseAsJSONParser.decode(input).map(res => new RubricRowBaseInputBaseAsJSON(res));
    }
    static unsafeDecode(input) {
        return RubricRowBaseInputBaseAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RubricRowBaseInputBaseAsJSONParser.encode(data);
    }
    static schema() {
        return RubricRowBaseInputBaseAsJSONParser.schema();
    }
}
